import {
  Box,
  Stack,
  styled
} from '@mui/material';



const TypingBall = styled(Box)<{ index: number }>(({ theme, index }) => ({
  width: 12,
  height: 12,
  borderRadius: 6,
  marginRight: 4,
  backgroundColor: theme.palette.grey[300],
  animation: 'bounce 500ms linear infinite',
  animationDelay: `${index * 250}ms`,
  animationDirection: 'alternate',
  opacity: 0.75,

  '@keyframes bounce': {
    '0%': {
      transform: 'translateY(0px)'
    },
    '100%': {
      transform: 'translateY(-4px)'

    }
  }
}));

export type LoadingMessageProps = {};

export const FC = (props: LoadingMessageProps) => {
  return (
    <Box sx={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      pb: 2
    }}
    >
      <Stack
        padding='1rem 1rem 1rem 0.75rem'
        sx={{
          backgroundColor: (theme) => theme.palette.primary.darker140
        }}
        borderRadius='0rem 1rem 1rem 1rem'
      >
        <Box sx={{
          display: 'flex'
        }}
        >
          <TypingBall index={0} />
          <TypingBall index={1} />
          <TypingBall index={2} />
        </Box>
      </Stack>
    </Box>
  );
};
